var _g, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStressRelievers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 53,
    viewBox: "0 0 44 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2_31405)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.2896,
    cy: 41.8425,
    rx: 12.2368,
    ry: 3.15789,
    fill: "#681414"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2896,
    cy: 21.7105,
    r: 21.7105,
    fill: "url(#paint0_linear_2_31405)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_31405",
    x: 2.05273,
    y: 30.6846,
    width: 40.4736,
    height: 22.3154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2_31405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_31405",
    x1: 13.2107,
    y1: 5.92321e-7,
    x2: 37.2896,
    y2: 48.5526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494912,
    stopColor: "#FF9922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressRelievers);
export default __webpack_public_path__ + "static/media/StressRelievers.9a266e0a091ad71cf7eb9eb9beec3725.svg";
export { ForwardRef as ReactComponent };